import React, {Fragment, useEffect, useState} from 'react';
import {selectLang, selectNumberFormat} from "../../../../store/reducers/main/main";
import {selectCardContractor} from "../../../../store/reducers/contractor/contractorReducer";
import {selectCurrency} from "../../../../store/reducers/currency/currencyReducer";
import {selectItems} from "../../../../store/reducers/item/itemReducer";
import {useSelector} from "react-redux";
import {Translate} from "../../../../lang/lang";
import {
    purchaseApproveAsync,
    purchasePayoutRegisterAsync,
    purchasePayoutUpdateAsync
} from "../../../../store/reducers/warehouse/purchaseReducer";
import toast from "react-hot-toast";
import {Card, Col, Row, Table} from "react-bootstrap";
import IconArrowLeft from "../../../../assets/icon/IconArrowLeft";
import {Link, useNavigate} from "react-router-dom";
import {scrollEvent} from "../../../../helpers/scrollEvent";
import IconEditPencil from "../../../../assets/icon/IconEditPencil";
import IconButton from "../../../IconButton";
import PurchasePrint from "./PurchasePrint";
import PurchaseDownloadPdf from "./PurchaseDownloadPdf";
import {isApprovedCheckedWarehouseOperation} from "../../../../enum/warehouse-operation/warehouseOperation";
import {
    PaymentTypeBankTransferCode,
    PaymentTypeBankTransferText, PaymentTypeCashCode, PaymentTypeCashText, PaymentTypeClickCode, PaymentTypeClickText,
    PaymentTypeHumoCode,
    PaymentTypeHumoText, PaymentTypePaymeCode, PaymentTypePaymeText,
    PaymentTypeUzCardCode,
    PaymentTypeUzCardText, PaymentTypeVisaCode, PaymentTypeVisaText
} from "../../../../enum/ContractorWrapper";
import numeral from "numeral";
import WarehouseOperationDatatableTab from "../WarehouseOperationDatatableTab";
import WarehouseOperationFooterCurrencyTotalSum from "../WarehouseOperationFooterCurrencyTotalSum";

const Purchase = ({purchase}) => {

    const [activeTab, setActiveTab] = useState("all")
    const numberFormat = useSelector(selectNumberFormat);
    const contractor = useSelector(selectCardContractor)
    const currencies = useSelector(selectCurrency)
    const items = useSelector(selectItems)
    const lang = useSelector(selectLang)
    const t = Translate
    const navigate = useNavigate()

    useEffect(() => {
        if (purchase?.items?.filter(f => !f?.is_deleted).length > 0) {
            setActiveTab("all")
        } else {
            setActiveTab("deleted")
        }
    },[currencies])

    const onSubmitPay = async (pay) => {
        if (purchase?.payout) {
            await purchasePayoutUpdateAsync({purchaseId: pay?.id, payout: pay?.payment})
                .then(() => {
                    toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
                })
                .catch(() => {
                    toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
                })
        }

        if (!purchase?.payout && purchase?.is_approved) {
            await purchasePayoutRegisterAsync({purchaseId: pay?.id, payout: pay?.payment})
                .then(() => {
                    toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
                })
                .catch(() => {
                    toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
                })

        }

        if (!purchase?.is_approved) {
            await purchaseApproveAsync({purchaseId: pay?.id, payout: pay?.payment || null})
                .then(() => {
                    toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
                })
                .catch(() => {
                    toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
                })
        }
    }

    useEffect(() => {
        window.addEventListener('scroll',() => scrollEvent('warehouse-purchase-register'));
        return () => window.removeEventListener('scroll', () => scrollEvent('warehouse-purchase-register'))
    }, []);

    return (
        <Fragment>
            <Row id={'warehouse-purchase-register'}
                 className="flex-between-center align-items-center my-3 position-sticky" style={{top: '4rem'}}>
                <Col cols={'auto'} className={'d-flex gap-3'}>
                    <button onClick={() => navigate(-1)} className={'main-text btn-back'}
                            style={{width: 35, height: 35}}>
                        <IconArrowLeft/>
                    </button>
                    <div>
                        <h5 className="fs-8 mb-0 text-nowrap py-2 py-xl-0">{t(lang, "warehouse.dashboard.items.purchase_title")} :
                            № {purchase?.number}</h5>
                        <span className={'second-text fs-9'}>{t(lang, 'warehouse.navbar.routes.warehouse')}</span>
                    </div>
                </Col>
                <Col cols={'auto'} className={'d-flex align-items-center justify-content-end gap-2 flex-wrap'}>
                    <IconButton
                        variant="phoenix-secondary"
                        as={Link}
                        to={`/operation/purchases/update/${purchase?.id}`}
                        className="btn-white-davr d-flex gap-2 align-items-center"
                    >
                        <IconEditPencil/>
                        {t(lang, "warehouse.operation.item.common.edit")}
                    </IconButton>
                    <PurchasePrint purchaseId={purchase?.id}/>
                    <PurchaseDownloadPdf
                        purchaseId={purchase?.id}
                        number={purchase?.number}
                    />
                </Col>
            </Row>
            <Card className={'p-1'}>
                <Card.Footer as={Row} className={'border-0 py-1'}>
                    <Col xs={12} md={6} className={'px-1'}>
                        <div className={'bg-card p-2 rounded-2'}>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span
                                        className={'second-text text-truncate d-block w-100'}>{t(lang, 'admin.organization.view.active_sessions.session.created_at')}</span>
                                </Col>
                                <Col md={8}>
                                    <span
                                        className={'main-text w-100 text-truncate d-block h-100'}>{purchase?.date}</span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span
                                        className={'second-text text-truncate d-block w-100'}>{t(lang, 'warehouse.operation.item.common.sale_status')}</span>
                                </Col>
                                <Col md={8}>
                                    <span
                                        className={'main-text w-100 text-truncate d-block h-100'}>{t(lang, isApprovedCheckedWarehouseOperation(purchase?.is_approved))}</span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span
                                        className={'second-text text-truncate d-block w-100'}>{t(lang, 'partners.common.sales.client')}</span>
                                </Col>
                                <Col md={8}>
                                    <span
                                        className={'main-text w-100 text-truncate d-block h-100'}>{purchase?.contractor?.name}</span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span className={'second-text text-truncate d-block w-100'}>{t(lang, PaymentTypeCashText)}</span>
                                </Col>
                                <Col md={8}>
                                    <span className={'main-text w-100 text-truncate d-flex gap-2 h-100'}>
                                        <span>{numeral['formats'][numberFormat].format(purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeCashCode)?.amount || 0)}</span>
                                        <span>{purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeCashCode)?.currency?.name}</span>
                                    </span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span
                                        className={'second-text text-truncate d-block w-100'}>{t(lang, PaymentTypeUzCardText)}</span>
                                </Col>
                                <Col md={8}>
                                    <span className={'main-text w-100 text-truncate d-flex gap-2 h-100'}>
                                        <span>{numeral['formats'][numberFormat].format(purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeUzCardCode)?.amount || 0)}</span>
                                        <span>{purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeUzCardCode)?.currency?.name}</span>
                                    </span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col xs={12} md={6} className={'px-1'}>
                        <div className={'bg-card p-2 rounded-2'}>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span
                                        className={'second-text text-truncate d-block w-100'}>{t(lang, PaymentTypeHumoText)}</span>
                                </Col>
                                <Col md={8}>
                                    <span className={'main-text w-100 text-truncate d-flex gap-2 h-100'}>
                                        <span>{numeral['formats'][numberFormat].format(purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeHumoCode)?.amount || 0)}</span>
                                        <span>{purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeHumoCode)?.currency?.name}</span>
                                    </span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span
                                        className={'second-text text-truncate d-block w-100'}>{t(lang, PaymentTypeBankTransferText)}</span>
                                </Col>
                                <Col md={8}>
                                    <span className={'main-text w-100 text-truncate d-flex gap-2 h-100'}>
                                        <span>{numeral['formats'][numberFormat].format(purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeBankTransferCode)?.amount || 0)}</span>
                                        <span>{purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeBankTransferCode)?.currency?.name}</span>
                                    </span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span
                                        className={'second-text text-truncate d-block w-100'}>{t(lang, PaymentTypeClickText)}</span>
                                </Col>
                                <Col md={8}>
                                    <span className={'main-text w-100 text-truncate d-flex gap-2 h-100'}>
                                        <span>{numeral['formats'][numberFormat].format(purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeClickCode)?.amount || 0)}</span>
                                        <span>{purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeClickCode)?.currency?.name}</span>
                                    </span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span
                                        className={'second-text text-truncate d-block w-100'}>{t(lang, PaymentTypePaymeText)}</span>
                                </Col>
                                <Col md={8}>
                                    <span className={'main-text w-100 text-truncate d-flex gap-2 h-100'}>
                                        <span>{numeral['formats'][numberFormat].format(purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypePaymeCode)?.amount || 0)}</span>
                                        <span>{purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypePaymeCode)?.currency?.name}</span>
                                    </span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                            <Row className={'py-1'}>
                                <Col md={4}>
                                    <span
                                        className={'second-text text-truncate d-block w-100'}>{t(lang, PaymentTypeVisaText)}</span>
                                </Col>
                                <Col md={8}>
                                    <span className={'main-text w-100 text-truncate d-flex gap-2 h-100'}>
                                        <span>{numeral['formats'][numberFormat].format(purchase?.payment?.cash_box_states?.find(i => i.payment_type === PaymentTypeVisaCode)?.amount || 0)}</span>
                                        <span>{purchase?.payout?.cash_box_states?.find(i => i.payment_type === PaymentTypeVisaCode)?.currency?.name}</span>
                                    </span>
                                    <hr className={'m-0 line-color'}/>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Card.Footer>
            </Card>

            <h4 className={'text-center my-2'}>{t(lang, "warehouse.operation.item.common.list.register")}</h4>

            <Card className={'p-1'}>
                <Card.Body className={'pb-1 pt-0 px-0'}>
                    <WarehouseOperationDatatableTab
                        dataItems={purchase?.items?.filter(f => !f.is_deleted)}
                    />
                    <WarehouseOperationFooterCurrencyTotalSum
                        netPrice={purchase?.net_price}
                        pay={purchase?.payout}
                    />
                </Card.Body>
            </Card>
        </Fragment>
);
};

export default Purchase;
